module.exports = __webpack_public_path__ + "static/media/plant.16a0c7cf.svg";